import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Form = _resolveComponent("Form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.visible) = $event)),
    width: "500"
  }, {
    activator: _withCtx(({}) => [
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: _ctx.open
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.dialog.button')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Form, null, {
        default: _withCtx(({ meta }) => [
          _createElementVNode("form", {
            onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_FocusLock, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.adressedialog.title')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "pb-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Field, {
                          modelValue: _ctx.teilnehmerCopy.firma,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.teilnehmerCopy.firma) = $event)),
                          name: "Firma",
                          rules: _ctx.getValidation('teilnehmerEditApiDto.firma')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.teilnehmerCopy.firma,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teilnehmerCopy.firma) = $event)),
                              autofocus: "",
                              clearable: "",
                              label: _ctx.$t('einstellungen.adressedialog.firma') + '*',
                              placeholder: _ctx.$t('einstellungen.adressedialog.firma'),
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.teilnehmerCopy.strasse,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teilnehmerCopy.strasse) = $event)),
                          name: "Strasse",
                          rules: _ctx.getValidation('teilnehmerEditApiDto.strasse')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.teilnehmerCopy.strasse,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teilnehmerCopy.strasse) = $event)),
                              label: _ctx.$t('einstellungen.adressedialog.strasse') + '*',
                              placeholder: _ctx.$t('einstellungen.adressedialog.strasse'),
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.teilnehmerCopy.zusatz,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.teilnehmerCopy.zusatz) = $event)),
                          label: _ctx.$t('einstellungen.adressedialog.zusatz'),
                          placeholder: _ctx.$t('einstellungen.adressedialog.zusatz')
                        }, null, 8, ["modelValue", "label", "placeholder"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.teilnehmerCopy.plz,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.teilnehmerCopy.plz) = $event)),
                          name: "Plz",
                          rules: _ctx.getValidation('teilnehmerEditApiDto.plz')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.teilnehmerCopy.plz,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.teilnehmerCopy.plz) = $event)),
                              label: _ctx.$t('einstellungen.adressedialog.plz') + '*',
                              placeholder: _ctx.$t('einstellungen.adressedialog.plz'),
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.teilnehmerCopy.ort,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.teilnehmerCopy.ort) = $event)),
                          name: "Ort",
                          rules: _ctx.getValidation('teilnehmerEditApiDto.ort')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.teilnehmerCopy.ort,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.teilnehmerCopy.ort) = $event)),
                              label: "Ort*",
                              placeholder: "Ort",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.teilnehmerCopy.telefon,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.teilnehmerCopy.telefon) = $event)),
                          name: "Telefon",
                          rules: _ctx.getValidation('teilnehmerEditApiDto.telefon') + '|valid_swiss_telephone_number'
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.teilnehmerCopy.telefon,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.teilnehmerCopy.telefon) = $event)),
                              label: _ctx.$t('einstellungen.adressedialog.telefon') + '*',
                              placeholder: _ctx.$t('einstellungen.adressedialog.telefon'),
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.teilnehmerCopy.email,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.teilnehmerCopy.email) = $event)),
                          name: "Email",
                          rules: _ctx.getValidation('teilnehmerEditApiDto.email')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.teilnehmerCopy.email,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.teilnehmerCopy.email) = $event)),
                              label: _ctx.$t('einstellungen.adressedialog.email') + '*',
                              placeholder: _ctx.$t('einstellungen.adressedialog.email'),
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "placeholder", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.teilnehmerCopy.bemerkungen,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.teilnehmerCopy.bemerkungen) = $event)),
                          label: _ctx.$t('einstellungen.adressedialog.bemerkung'),
                          placeholder: _ctx.$t('einstellungen.adressedialog.bemerkung')
                        }, null, 8, ["modelValue", "label", "placeholder"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { class: "ml-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: !meta.valid,
                          color: "primary",
                          type: "submit",
                          variant: "flat",
                          class: "modalbutton mb-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          class: "modalbutton mb-3",
                          variant: "flat",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.visible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}